import tenantsQuery from "./graphql/tenants_query.graphql";
import { runQuery } from "@/api/query";

export const queryTenants = async () => {
  const result = await runQuery(tenantsQuery);
  return result ? result.tenants.edges.map((edge) => edge.node) : [];
};
